import { useState, useEffect, useRef } from 'react';
//import iNoBounce from 'inobounce';
//import browser from 'browser-detect';

const Promo = ({ timer }) => {
    const [activePage, setActivePage] = useState(0);
    const blockRef = useRef(null);
    //iNoBounce.disable();
    //const result = browser();

    useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const blockTop = blockRef.current.offsetTop;
      const blockHeight = windowHeight * 1.3; // Два экрана
      
      if (window.screen.width < 1024) {  
        if (scrollY >= blockTop && scrollY < blockTop + blockHeight) {
            const currentPage = Math.floor((scrollY - blockTop) / windowHeight);
            setActivePage(Math.min(currentPage, 1)); // Ограничиваем двумя страницами
        } 
      }
    };

    // Добавляем обработчик события
    window.addEventListener('scroll', handleScroll);
    
    // Вызываем сразу для установки начального состояния
    handleScroll();

    // Убираем обработчик при размонтировании
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
    return (
    <section className={`promo `} ref={blockRef}>
        <div className={`invite `} >
            <div className={`invite__skroll-block ${activePage === 0 ? 'active' : ''} invite__skroll-block_center `}>
                <div className="invite__marryned"> 
                    <p className="margin-none fs-3m" >Илья</p>
                    <div className="heart" ></div>
                    <p className="margin-none fs-3m" >Лера</p>
                </div>
                <p className="margin-none invite__text" >Мы рады пригласить вас на торжество, которое станет одним из самых важных и запоминающихся событий в нашей жизни. Ваше присутствие сделает этот день еще более особенным и значимым для нас. Именно рядом с самыми близкими людьми мы хотим отпраздновать начало нового этапа нашей совместной жизни.</p>
            </div>
            <div className={`invite__skroll-block ${activePage === 1 ? 'active' : ''} `}>
                <div className="invite__date margin-none fw-400 fs-20" >
                    <p className="margin-none ff-caveat fs-32">16 </p>
                    <p className="margin-none ff-caveat fs-32">января </p>
                    <p className="margin-none ff-caveat fs-32">2026</p>
                </div>
                <div className="timer">
                    <p className="timer__title margin-none fs-20" >До начала свадьбы осталось:</p>
                    <div>
                        <p className="margin-none fw-400 fs-3m ff-caveat" >{timer !== null ? timer.days : 0}</p>
                        <p className="margin-none fs-20" >дней</p>
                    </div>
                    <div>
                        <p className="margin-none fw-400 fs-3m ff-caveat" >{timer !== null ? timer.hours : 0}</p>
                        <p className="margin-none fs-20" >часов</p>
                    </div>
                    <div>
                        <p className="margin-none fw-400 fs-3m ff-caveat" >{timer !== null ? timer.minutes : 0}</p>
                        <p className="margin-none fs-20" >минут</p>
                    </div>
                    <div>
                        <p className="margin-none fw-400 fs-3m ff-caveat" >{timer !== null ? timer.seconds : 0}</p>
                        <p className="margin-none fs-20" >секунд</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
};

export default Promo;